import SearchNotFoundAnimation from "../../../components/SearchNotFoundAnimation";
import { formatRelativeTime } from "../../../utils/formatUTCtoLocalDate";
import { useAppSelector } from "../../../utils/hooks";
import StatusProfile from "./StatusProfile";
import { useTimeFormatOptions } from "../../../hooks/useTimeFormatOptions";
import TextTranslate from "../../../utils/TextTranslate";

export default function ViewedStatusList() {
  const statusData = useAppSelector((state) => state.status);
  const userData = useAppSelector((state) => state.userData);
  const { translate, hour12 } = useTimeFormatOptions();

  const items =
    statusData?.data?.viewed_stories?.filter(
      (item) => item.user_id !== userData.user_id,
    ) ?? [];

  if (items.length === 0) {
    return (
      <div className="grid place-content-center gap-4 px-4 py-16 text-center text-lightText">
        <SearchNotFoundAnimation />
        <div>
          <TextTranslate text="No Status Found" />
        </div>
      </div>
    );
  }

  return (
    <div className="[&>*+*]:border-t [&>*+*]:border-black/[0.06] dark:[&>*+*]:border-white/[0.08]">
      {items.map((item) => (
        <StatusProfile
          key={item.stories[0].story_id}
          name={item.full_name}
          profile_url={item.profile_pic}
          time={formatRelativeTime(item.updatedAt, { translate, hour12 })}
          currentStatusId={item.stories[0].story_id}
          viewed
        />
      ))}
    </div>
  );
}
